import React from 'react';

const MoedaContext = React.createContext();

export default MoedaContext;
